import { PropsWithChildren } from 'react';
import { calculateBudgetPercentage } from 'utils/object';
import { formatCurrency } from 'utils/string/currency';

export type DashboardSummary = {
  name: string;
  budgetTotal: number;
  realizedTotal: number;
};

export default function SummaryComponent({
  children,
  ...summary
}: PropsWithChildren<DashboardSummary>) {
  return (
    <div className="row justify-between pt-s-400  pl-s-550 pr-s-550">
      <div className="col pb-s-400">
        <div className="row gap-x-1">
          <div className="col">
            <div className="card !border-radius-100 !border-color-primary-30">
              <div className="card__body">
                <div className="pl-s-100 pr-s-100 pt-s-50 pb-s-50 d-flex flex-direction-column align-items-center">
                  <p className="text-neutral-variant-60 font-weight-medium font-s-125 line-height-medium">
                    {summary.name}
                  </p>
                  <p className="font-weight-semibold text-primary-30 line-height-medium">
                    {formatCurrency(summary.budgetTotal)}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col">
            <div className="card !border-radius-100 !border-color-primary-30">
              <div className="card__body">
                <div className="pl-s-100 pr-s-100 pt-s-50 pb-s-50 d-flex flex-direction-column align-items-center">
                  <p className="text-neutral-variant-60 font-weight-medium font-s-125 line-height-medium">
                    Realizado
                  </p>
                  <p className="font-weight-semibold text-primary-30 line-height-medium">
                    {formatCurrency(summary.realizedTotal)}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col">
            <div className="card !border-radius-100 !border-color-primary-30">
              <div className="card__body">
                <div className="pl-s-100 pr-s-100 pt-s-50 pb-s-50 d-flex flex-direction-column align-items-center">
                  <p className="text-neutral-variant-60 font-weight-medium font-s-125 line-height-medium">
                    Alcançado (%)
                  </p>
                  <p className="font-weight-semibold text-primary-30 line-height-medium">
                    {calculateBudgetPercentage(summary)} %
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col pb-s-400">{children}</div>
    </div>
  );
}
